import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function VehicleTypeRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/vehicle-type', component: Index, isProtected: true, permissions: ['vehicle_type_index']},
    {path: '/vehicle-type/create', component: Create, isProtected: true, permissions: ['vehicle_type_create']},
    {path: '/vehicle-type/edit/:id', component: Edit, isProtected: true, permissions: ['vehicle_type_edit']},

  ];

  return routes;
}
